<template>
  <div class='opc-succezz-thx currency-switch' :class="{
    'opc-modal': $context.is.modal
  }">
    <div class='opc-succezz-thx__status'>
      <img src='@/assets/success/confirmation_check.svg' alt=''>
    </div>
    <h1 class='opc-succezz-thx__title' :aria-label='title'>{{ title }}</h1>
    <div class='opc-succezz-thx__sub-title'>
      <span v-html="subtitle"></span>
    </div>
    <div class='opc-succezz-thx__actions OPC_SUCCEZZ_THX_ACTIONS_FOR_CONFIRMATION_EMAIL' :class="{
      'opc-modal': $context.is.modal
    }">
      <zm-button 
        type="primary" 
        size="large" 
        round 
        :data-url="billingUrl"
        data-cta-type="primary"
        @click="goToBillingPayment"
      >
        {{ reviewBillingPaymentText }}
      </zm-button>
      <zm-button 
        plain
        size="large" 
        round 
        :data-url="billingUrl"
        data-cta-type="primary"
        @click="goToBilling"
      >
        {{ reviewBillingText }}
      </zm-button>
    </div>
    <partner-promote />
  </div>
</template>

<script>
import PartnerPromote from '@/views/succezz/components/partner-promote.vue';

export default {
  name: 'CurrencySwitch',
  components: {
    PartnerPromote
  },
  computed: {
    title() {
      return this.$t('billing.currency_switch.submit_thank_you');
    },
    subtitle() {
      return this.$t('billing.currency_switch.processing_message');
    },
    reviewBillingText() {
      return this.$t('billing.success.review_your_subscription');
    },
    reviewBillingPaymentText() {
      return this.$t('billing.currency_switch.review_billing_info');
    },
    billingUrl() {
      return '/billing';
    },
    billingPaymentUrl() {
      return '/billing/payment';
    }
  },
  methods: {
    goToBilling() {
      window.location.href = this.billingUrl;
    },
    goToBillingPayment() {
      window.location.href = this.billingPaymentUrl;
    }
  }
};
</script>

<style lang='scss' scoped>
@import '@zoom/billing-responsive/styles/responsive.scss';
@import '@/styles/_variables.scss';

.currency-switch {
  .opc-succezz-thx__title {
    font-family: $happy-display;
    font-size: 32px;
    font-weight: 600;
    line-height: 38.4px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .opc-succezz-thx__sub-title {
    font-family: Almaden Sans;
    font-size: 18px;
    font-weight: 400;
    line-height: 32px;
    margin-top: 6px;
    word-break: break-word;
  }

  .opc-succezz-thx__actions {
    margin-top: 24px;
    
    &.opc-modal {
      @include media(tablet) {
        .zm-button.zm-button--primary.zm-button--large.is-round {
          width: auto;
          min-width: 120px;
          border-radius: 10px;
        }
      }
      .zm-button {
        margin-top: 8px !important;
        width: auto !important;
        border-radius: 10px !important;
        display: inline-block !important;
      }
    }
    
    .zm-button.zm-button--primary.zm-button--large.is-round {
      min-width: unset;
      padding: 8px 24px;
      border-radius: 24px;
    }

    @include media(mobile, tablet) {
      ::v-deep .zm-button {
        width: 100%;
        padding: $mobile-space/2;
        border-radius: $mobile-space;
      }
    }
  }

  .opc-succezz-thx__status {
    font-size: 36px;
    color: #95ebb2;
    margin-bottom: 12px;
  }

  &.opc-modal {
    text-align: center;

    .opc-succezz-thx__title {
      text-align: center;
      font-family: $happy-display;
      font-size: 29.778px;
      font-style: normal;
      font-weight: 600;
      line-height: 120%;
    }
  }
}
</style>
